import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const SearchIndexDefinitionSchema = withDefaults({
  // No 'search-' prefix, despite the file's own RFC-055 grouping name: this must match the wire
  // type JSONAPI::Resources derives from the bare Api::V2::Admin::IndexDefinitionResource class
  // name (-> 'index-definitions', normalized to singular-dasherized by TioTypeNormalizationHandler),
  // not the Ruby model's own namespaced name (Search::IndexDefinition).
  type: 'index-definition',
  fields: [
    {
      kind: 'attribute',
      name: 'modelClassName',
    },
    {
      kind: 'attribute',
      name: 'indexName',
    },
    {
      kind: 'attribute',
      name: 'settings',
    },
    {
      kind: 'attribute',
      name: 'dynamicTemplateKeys',
    },
    {
      kind: 'attribute',
      name: 'shouldIndexMethod',
    },
    {
      kind: 'attribute',
      name: 'importScope',
    },
    {
      kind: 'attribute',
      name: 'enabled',
    },
    {
      kind: 'attribute',
      name: 'version',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'hasMany',
      name: 'dataPoints',
      type: 'data-point',
      options: {
        async: false,
        inverse: 'indexDefinition',
      },
    },
    {
      kind: 'hasMany',
      name: 'dataSetMembers',
      type: 'data-set-member',
      options: {
        async: false,
        inverse: 'indexDefinition',
      },
    },
  ],
});

export default SearchIndexDefinitionSchema;
